import React from 'react';
import { BrowserRouter as Router, Routes, Route, UNSAFE_DataRouterContext, UNSAFE_DataRouterStateContext } from 'react-router-dom';
import WaitlistPage from './pages/WaitlistPage';
import UploadPage from './pages/UploadPage';
import NavBar from './components/NavBar';
import Aurora from './components/Aurora';
import { ThemeProvider, createTheme, Box } from '@mui/material';
import { Mail, Upload } from 'lucide-react';

const theme = createTheme({
  palette: {
    primary: {
      main: '#E65A2F',
      light: 'rgba(230, 90, 47, 0.1)', // Lighter version for hover states
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
      },
    },
  },
});

const navItems = [
  { name: 'Waitlist', url: '/', icon: Mail },
  { name: 'Upload', url: '/upload', icon: Upload }
];

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Box sx={{ 
          position: 'relative', 
          minHeight: '100vh',
          background: 'transparent',
          display: 'flex',
          flexDirection: 'column',
          pt: '25vh' // Add padding top to account for Aurora height
        }}>
          <Aurora
            colorStops={["#8B1D1D", "#E65A2F", "#D4432A"]}
            blend={0.5}
            amplitude={2.0}
            speed={0.8}
          />
          <Box sx={{ 
            position: 'relative',
            zIndex: 2,
            backgroundColor: 'transparent',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            mt: '-25vh' // Negative margin to counter the padding
          }}>
            <NavBar items={navItems} />
            <Routes>
              <Route path="/" element={<WaitlistPage />} />
              <Route path="/upload" element={<UploadPage />} />
            </Routes>
          </Box>
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
